import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=5fa62503&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"
import style0 from "./Notification.vue?vue&type=style&index=0&id=5fa62503&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa62503",
  null
  
)

export default component.exports